@if (enabled$ | async) {
  <div class="signalr-status-container">
    @let hubConnectionState = hubConnectionState$ | async;
    @if (hubConnectionState === 'Connected') {
      <span title="Server Connected"><i class="ra-icon-ide-sm-color-status-indicator-circle-check"></i></span>
    }
    @if (hubConnectionState === 'Disconnected') {
      <span title="Disconnected"><i class="ra-icon-ide-sm-color-status-indicator-circle-offline"></i></span>
    }
    @if (hubConnectionState === 'Reconnecting') {
      <span title="Reconnecting"><i class="ra-icon-ide-sm-color-status-indicator-circle-warning connecting"></i></span>
    }
    @if (hubConnectionState === 'Connecting') {
      <span title="Connecting"><i class="ra-icon-ide-sm-color-status-indicator-circle-info connecting"></i></span>
    }
    @if (hubConnectionState === undefined) {
      <span title="Offline"><i class="ra-icon-ide-sm-color-status-indicator-circle-offline"></i></span>
    }
  </div>
}
